// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.MainPagecart {\n  background-color: #F6EBE7; }\n\ndiv.MainPageerror {\n  background-color: #E6F5EE; }\n", ""]);
// Exports
module.exports = exports;
